import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BillingPaymentsProvider  } from '../../providers/billing-payments/billing-payments';
import { TranslateService } from '@ngx-translate/core';
import { ToastProvider } from '../../providers/toast/toast';

@IonicPage()
@Component({
  selector: 'page-bill-report',
  templateUrl: 'bill-report.html',
})
export class BillReportPage {

  public barChartLabels:string[] = [];
	public barChartType:string = 'horizontalBar';
	public barChartLegend:boolean = true;

  public barChartData:any[] = [];
  
  public height = 300;
  selRegistrationLogin : any;

  constructor(public navCtrl: NavController, 
	private translate: TranslateService,
	  public navParams: NavParams,
	  private toast: ToastProvider,
  	public bpProvider: BillingPaymentsProvider) {
		this.selRegistrationLogin = localStorage.getItem('signup_login')

		if(this.selRegistrationLogin){
		  this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
		}
	else{
  	bpProvider.getBillReportData().then(val => {
  		if(val.status == "success"){
        this.generateChart(val.data);
        this.height = val.data[0].height;
  		}
	  });
	}
  }

  generateChart(data){
  	for(let i=1; i<data.length; i++ ){
  		this.barChartLabels.push(data[i][0]);
  	}
  	for(let i=1; i<data[0].length; i++){
  		let x = [];
  		for(let j=1; j<data.length; j++){
  			x.push(data[j][i]);
  		}
  		this.barChartData.push({
  			data: x,
  			label: data[0][i]
  		});
  	}
  }

	public barChartOptions:any = {
	  scaleShowVerticalLines: false,
	  responsive: true,
    maintainAspectRatio: false,
	  scales: {
    yAxes: [{
        categoryPercentage: .8,
        barPercentage: 1,
      },
      ]  
    },
    legend: {
      position: 'bottom',
      labels: {
        boxWidth: 20,
      }
    }
	};

	public chartClicked(e:any):void {
	  console.log(e);
	}

	public chartHovered(e:any):void {
	  console.log(e);
	}

  ionViewDidLoad() {
    console.log('ionViewDidLoad BillReportPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/bill-report/bill-report.ts